import(/* webpackMode: "eager" */ "/opt/build/repo/app/faq/page.tsx")